import {
    ContactActions,
    ContactMessageRequest,
} from "@/business/contact/domain/contactRequest";
import { generateUUID } from "@/business/shared/commons/uuid/uuid";
import { createContactService } from "@/business/contact/infrastructure/services/createContactService";

export const createContactMessage = {
    async execute(
        name: string,
        email: string,
        phone: string,
        message: string
    ): Promise<void> {
        const request: ContactMessageRequest = ContactActions().createRequest(
            generateUUID(),
            name,
            email,
            phone,
            message
        );
        await createContactService.execute(request);
    },
};
